<template>
  <div>
    <v-breadcrumbs :items="crumbs"></v-breadcrumbs>
    <base-loader :isLoading="isLoading"></base-loader>
    <v-row>
      <v-col md="6">
        <v-card>
          <v-card-text>
            <h4 class="text-md-h4 primary--text mb-5">HqName Details</h4>
            <v-simple-table v-if="$route.params.id != 0">
              <tbody>
                <tr>
                  <td>HqName Name</td>
                  <td>
                    {{ hqNameModel.name ? hqNameModel.name : "" }}
                  </td>
                </tr>
                <tr>
                  <td>HqName Id</td>
                  <td>
                    {{ hqNameModel.id ? hqNameModel.id : "" }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>

            <v-btn
              v-if="$route.params.id == 0"
              color="primary"
              large
              :to="`${$route.path}/edit`"
              class="mr-2"
              >Create a New HqName</v-btn
            >
            <v-btn
              v-else
              large
              color="primary"
              :to="`${$route.path}/edit`"
              class="mr-2"
              >Edit</v-btn
            >
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { HqName } from "@/models/HqName";
import { gql } from "apollo-boost";
export default {
  data() {
    return {
      isEdit: false,
      hqNameModel: new HqName(),
      me: "",
      search: null,
      crumbs: [
        {
          text: "HqNames",
          disabled: false,
          href: "/admin/hqNames",
        },
        {
          text: "HqName Details",
          disabled: false,
          href: `/admin/hqName/${this.$route.params.id}`,
        },
      ],
    };
  },
  created() {},
  apollo: {
    me: gql`
      query {
        me {
          id
        }
      }
    `,
    hqName: {
      query: gql`
        query HqName($id: ID!) {
          hqName(id: $id) {
            id
            name
            createdBy
            createdAt
            updatedAt
          }
        }
      `,
      fetchPolicy: "network-only",
      skip() {
        return !this.$route.params.id || this.$route.params.id == 0;
      },
      variables() {
        const self = this;
        return {
          id: self.$route.params.id,
          createdBy: self.me.id,
        };
      },
      watchLoading(isLoading) {
        this.isLoading = isLoading;
      },
      result(response, key) {
        this.isLoading = false;
        this.hqNameModel.id = this.hqName.id;
        this.hqNameModel.name = this.hqName.name;
        this.hqNameModel.createdBy = this.hqName.createdBy;
      },
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped></style>
